import { render } from "./UploadFormModal.vue?vue&type=template&id=42e70030"
import script from "./UploadFormModal.vue?vue&type=script&lang=js"
export * from "./UploadFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__